export default "__VITE_ASSET__C3y821fS__"